const MuiMenuItem = {
  styleOverrides: {
    root: {
      fontSize: '1.4rem',
    },
  },
};
export default MuiMenuItem;
